import styled from "styled-components";

const StyledQuestion = styled.div`
  align-self: end;
  max-width: 70%;

  padding: 0.75rem;
  border-radius: 1.5rem 0 1.5rem 1.5rem;
  gap: 1rem;

  color: var(--chat-color);
  text-align: end;

  border: 1px solid var(--color-border);
`;

function Question({ message }) {
  return <StyledQuestion>{message.message}</StyledQuestion>;
}

export default Question;
